import { TodoField } from '@shared/data/entity/fields/TodoField';
import { i18n } from '@shared/util/i18n';

/** How many of a to-do list's items are done, out of how many. */
export function getTodoProgress(field: TodoField): { completed: number; total: number } {
  const completed = field.todos.filter(todo => todo.status === 'COMPLETED').length;
  return { completed, total: field.todos.length };
}

/** A to-do list as one line of text: its progress, "2 of 4". */
export function getTodoText(field: TodoField): string {
  return i18n('card.blocks.subtableInput.todoCount', getTodoProgress(field));
}
